import type { ModalStaticFunctions } from 'antd/es/modal/confirm';

import { FileSecretDetail } from '../components/Viewer/FileSecretDetail';
import type File from '../interfaces/File';

type ConfirmModal = Pick<ModalStaticFunctions, 'confirm'>;

/**
 * Open a .fgsecret in an App modal (same comfort shell as create SecretFileForm).
 * Reuses FileSecretDetail → ViewerFileSecret load/decrypt/edit path.
 */
export function openSecretFileModal(modal: ConfirmModal, file: File) {
  const modalInstance = modal.confirm({
    title: file.fileName,
    width: 700,
    content: <FileSecretDetail file={file} onClose={() => modalInstance.destroy()} />,
    footer: null,
    mask: { closable: true },
  });
  return modalInstance;
}
